import { forwardRef, useEffect } from 'react';
import { ElementThemeUnion } from 'constants/routes';

import TextInput from '../TextInput';

interface SearchInput {
  searchQuery: string;
  onSearchChange: (option: string) => void;

  searchPlaceholder?: string;
  theme?: ElementThemeUnion;
}

const SearchInput = forwardRef<HTMLInputElement, SearchInput>((props, ref) => {
  const {
    searchQuery,
    onSearchChange,
    searchPlaceholder = '',
    theme = 'light',
  } = props;

  const handleInputChangeAdapter = (value: string) => {
    const fakeEvent = {
      target: { value },
    } as React.ChangeEvent<HTMLInputElement>;
    handleInputChange(fakeEvent);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    onSearchChange(value);
  };

  useEffect(() => {
    onSearchChange(searchQuery);
  }, [searchQuery]);

  return (
    <TextInput
      ref={ref}
      value={searchQuery}
      onChange={handleInputChangeAdapter}
      size="m"
      type="text"
      classNames={{
        container:
          'sticky top-0 z-10 border-b border-solid border-tpg_light [&_svg]:w-5 [&_svg]:h-5',
        input: 'tpg-c2 !pl-9 !text-tpg_light ',
      }}
      searchIcon
      placeholder={searchPlaceholder}
      theme={theme}
    />
  );
});

SearchInput.displayName = 'SearchInput';

export default SearchInput;
